export const AuthEndpoint = {
  LOGIN: '/api/admin/auth/login',
};
